import {
  DEFAULT_EVENT_URL,
  DEFAULT_MONITORING_URL,
  DEFAULT_POOL_INTERVAL,
  DEFAULT_SDK_URL,
  SDK_VERSION,
  STATIC_EVENT_URL,
  STATIC_MONITORING_URL,
  STATIC_SDK_URL
} from "../../config"
import { Config, Sdk } from "../../index.node"
import Logger, { logLevels } from "../../core/internal/logger"
import { Metrics } from "../../core/internal/metrics/Metrics"

interface InternalConfig {
  debug: boolean
  log_disabled: boolean
  pollingIntervalMillis: number

  sdkUrl: string
  eventUrl: string
  monitoringUrl: string
  enableMonitoring: boolean
}

const DEFAULT_CONFIG: InternalConfig = {
  debug: false,
  log_disabled: false,
  pollingIntervalMillis: DEFAULT_POOL_INTERVAL,

  sdkUrl: DEFAULT_SDK_URL,
  eventUrl: DEFAULT_EVENT_URL,
  monitoringUrl: DEFAULT_MONITORING_URL,
  enableMonitoring: true
}

const STATIC_REGION = {
  sdkUrl: STATIC_SDK_URL,
  eventUrl: STATIC_EVENT_URL,
  monitoringUrl: STATIC_MONITORING_URL
}

export class Configurations {
  static config = (config?: Config): InternalConfig => {
    let cfg: InternalConfig = {
      ...DEFAULT_CONFIG,
      ...config
    }

    if (config && config.region === "STATIC") {
      cfg = {
        ...cfg,
        ...STATIC_REGION
      }
    }

    return cfg
  }

  static logging = (config: InternalConfig) => {
    Logger.initCounter((logLevel) => Metrics.counter("log", { level: logLevel }))
    Logger.setLogLevel(logLevels.INFO)
    if (config.log_disabled) {
      Logger.setLogLevel(logLevels.DISABLE)
    } else {
      if (config.debug) {
        Logger.setLogLevel(logLevels.DEBUG)
      }
    }
  }

  static sdk = (sdkKey: string): Sdk => {
    Logger.log.debug(`SDK key: ${sdkKey}`)
    if (!sdkKey) {
      Logger.log.error(`invalid sdk key: '${sdkKey}' (expected: not null, not undefined and not empty string)`)
    }
    return {
      key: sdkKey,
      name: "javascript-sdk_node",
      version: SDK_VERSION
    }
  }

  static pollingIntervalMillis = (config: InternalConfig): number => {
    if (config.pollingIntervalMillis === undefined) {
      return DEFAULT_POOL_INTERVAL
    }

    // noinspection SuspiciousTypeOfGuard
    if (typeof config.pollingIntervalMillis !== "number") {
      return DEFAULT_POOL_INTERVAL
    }

    return Math.max(DEFAULT_POOL_INTERVAL, config.pollingIntervalMillis)
  }
}
